// 养护日报
const Url = '/business/yhProjectDaily/' // 日报

const Url2 = '/business/yhDailyTemplate/' // 日报模板

export default {
  selectYhProjectDailyByPage: Url + 'selectYhProjectDailyByPage',
  insertYhProjectDaily: Url + 'insertYhProjectDaily',
  updateYhProjectDaily: Url + 'updateYhProjectDaily',
  selectYhProjectDailyShareDetail: Url + 'selectYhProjectDailyShareDetail',
  checkYhProjectDaily: Url + 'checkYhProjectDaily',
  selectDailyTomorrowPlan: Url + 'selectDailyTomorrowPlan',
  selectDailyOrder: Url + 'selectDailyOrder',
  deleteYhProjectDaily: Url + 'deleteYhProjectDaily',
  selectYhProjectDailyTomorrowPlanList: Url + 'selectYhProjectDailyTomorrowPlanList',
  selectYhDailyTemplateByPage: Url2 + 'selectYhDailyTemplateByPage',
  insertYhDailyTemplate: Url2 + 'insertYhDailyTemplate',
  updateYhDailyTemplate: Url2 + 'updateYhDailyTemplate',
  disableYhDailyTemplate: Url2 + 'disableYhDailyTemplate',
  deleteYhDailyTemplate: Url2 + 'deleteYhDailyTemplate',
  selectYhDailyTemplateByTemplateId: Url2 + 'selectYhDailyTemplateByTemplateId',
  selectYhProjectDailyTemplateList: Url2 + 'selectYhProjectDailyTemplateList',
  selectProjectOptionList: Url2 + 'selectProjectOptionList',
  selectLabourServiceStatisticByDaily: '/business/yhAttendanceStatistics/selectLabourServiceStatisticByDaily',
  selectYhProjectDailyDateList: Url + 'selectYhProjectDailyDateList',
  selectYhDetailedDaily: '/business/yhDetailed/selectYhDetailedDaily',
  selectYhMachineTeamLineByList: '/business/yhMachineTeam/selectYhMachineTeamLineByList'
}
